import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

// Lazy: the page uses Ant Design, which stays out of the main dashboard bundle.
const Loqate = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/loqate'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'loqate_settings_index',
          component: Loqate,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
